module.exports = __webpack_public_path__ + "static/carbon-toast-3a786f9ed5b7612e258360b74524a6d8.png";